var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c("span", { ref: "tooltipTarget" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.componentReady
        ? _c(
            "b-tooltip",
            {
              attrs: {
                "custom-class": "plan-tooltip",
                target: _vm.$refs.tooltipTarget,
                triggers: "focus hover",
                variant: "danger",
                disabled: _vm.tooltipDisabled,
                placement: _vm.placement,
                show: _vm.show,
              },
              on: {
                "update:show": function ($event) {
                  _vm.show = $event
                },
              },
            },
            [
              _c("account-usage-message", {
                attrs: {
                  page: _vm.page,
                  "usage-restricted": _vm.usageRestricted,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }